import { Box, Button, Grid, Typography } from '@mui/material';
import React, { useContext, useState } from 'react';
import { makeStyles } from 'tss-react/mui';
import { AppContext } from '@/utils/appContext';
import { useTranslation } from 'react-i18next';
import { toast } from 'react-toastify';
import CloseIcon from '@mui/icons-material/Close';
import { TabContext, TabPanel } from '@mui/lab';
import myhu from '../../../assets/img/myhu.png';
import SelectDestinationField from './SelectDestinationField';
import SelectDateField from './SelectDateField';
import SetGuestsField from './SetGuestsField';
import SetCouponField from './SetCouponField';
import { website } from '@/utils/helpers';
import { UnauthenticatedTemplate } from '@azure/msal-react';

export const SearchBarPopup = (props: any) => {
  const appContext = useContext(AppContext);
  const { t } = useTranslation();
  const { classes } = useStyles();

  const [openModalDestinationPicker, setOpenModalDestinationPicker] = useState(false);
  const [openHolidayTypeModal, setOpenHolidayTypeModal] = useState(false);
  const handleOpenModalDestinationPicker = () => setOpenModalDestinationPicker(true);
  const handleCloseModalDestinationPicker = () => setOpenModalDestinationPicker(false);
  const handleOpenHolidayTypeModal = () => setOpenHolidayTypeModal(true);
  const handleCloseHolidayTypeModal = () => setOpenHolidayTypeModal(false);

  const [openModalDatePicker, setOpenModalDatePicker] = useState(false);
  const handleOpenModalDatePicker = () => setOpenModalDatePicker(true);
  const handleCloseModalDatePicker = () => setOpenModalDatePicker(false);

  const [openGuestsModal, setOpenGuestsModal] = useState(false);
  const handleOpenGuestsModal = () => setOpenGuestsModal(true);
  const handleCloseGuestsModal = () => {
    const mergedChildsArray = mergeChildFromAccommodations(appContext.searchForms);

    if (
      mergedChildsArray.ageOfChildren.length > 0 &&
      mergedChildsArray.ageOfChildren.includes(null)
    ) {
      toast.warning('Ricordati di indicare l\'età dei bambini prima di continuare');
    } else {
      /*props.params.sumGuests();*/
      setOpenGuestsModal(false);
    }
  };

  function mergeChildFromAccommodations(arr: any[]) {
    const result: any = {};

    arr.forEach((obj: any) => {
      for (const prop in obj) {
        if (Array.isArray(obj[prop])) {
          if (!result[prop]) {
            result[prop] = [];
          }
          result[prop].push(...obj[prop]);
        }
      }
    });
    return result;
  }

  const setQuantity = props.params.setQuantity;
  const setPets = props.params.setPets;

  /*const value = props.params.value;

  const handleWhereChange = props.params.handleWhereChange;
  const setQuantity = props.params.setQuantity;
  const handlePets = props.params.handlePets;
  const sumGuests = props.params.sumGuests;
  const locale = props.params.locale;
  const addSearchForm = props.params.addSearchForm;
  const removeSearchForm = props.params.removeSearchForm;
  const handleChangeType = props.params.handleChangeType;*/

  const [tab, setTab] = useState('1');

  const container = props.container;

  const [openDestinationModal, setOpenDestinationModal] = useState<boolean>(false);

  return (
    <Box p={4} pb={5} className={classes.root}>
      <TabContext value={tab}>
        <Grid container>
          <Grid onClick={() => props.params.hideSidebar()} sx={{ cursor: 'pointer' }}>
            <CloseIcon />
          </Grid>
          <Grid>
            {/*<Box sx={{borderBottom: 1, borderColor: 'divider'}}>
                <TabList onChange={handleChangeTab}>
                    <Tab label="Soggiorno" value="1"/>
                </TabList>
            </Box>*/}
          </Grid>
        </Grid>

        <TabPanel value="1" sx={{ padding: 0, height: '100%' }}>
          <Grid container direction={'column'} justifyContent={'space-between'} alignItems={'space-between'}
                height={'100%'}>
            <Grid>
              {website.code === 'HU' && (
                <>
                  <Box pt={3} pb={1}>
                    <Typography variant={'h6'} component={'h6'}>
                      {t('Where_we_going?')}
                    </Typography>
                  </Box>
                  <SelectDestinationField params={{ container }} />
                </>
              )}
              <Box pt={2} pb={1}>
                <Typography variant={'h6'} component={'h6'}>
                  {t('When?')}
                </Typography>
              </Box>
              <SelectDateField params={{ container }} />
              <Box pt={2} pb={1}>
                <Typography variant={'h6'} component={'h6'}>
                  {t('Chi viaggia con te?')}
                </Typography>
              </Box>
              <SetGuestsField params={{ setQuantity, setPets, container }} />
              <Box pt={2} pb={1}>
                <Typography variant={'h6'} component={'h6'}>
                  Coupon
                </Typography>
              </Box>
              <SetCouponField params={{ container }} />
              <Box mt={5}>
                <Button variant={'contained'} fullWidth className={classes.confirmBtn}
                        onClick={props.params.handleSubmit}>{t('start_search')}</Button>
              </Box>
            </Grid>

            {
              website.code !== 'VP' && (
                <>
                  {!appContext.accountData && (
                    <UnauthenticatedTemplate>
                      <Grid mb={3}>
                        <Grid container direction={'row'} alignItems={'center'} pt={3}>
                          <Grid size={{ xs: 6 }}>
                            <Box pr={5}>
                              <Typography variant={'h6'} component={'h6'}>
                                {t('Accedi_al_profilo')} <img alt={'login'} src={myhu} />
                              </Typography>
                            </Box>
                            <Typography variant={'body2'} component={'span'} onClick={() => appContext.handleLogin()}
                                        sx={{ cursor: 'pointer' }}>
                              {t('Non_hai_ancora_un_profilo?')}
                              <br /> {t('Registrati_ora')}
                            </Typography>
                          </Grid>
                          <Grid size={{ xs: 6 }}>
                            <Button
                              onClick={() => appContext.handleLogin()}
                              fullWidth
                              variant={'outlined'}
                              sx={{
                                color: '#000!important',
                                borderColor: '#000!important',
                                borderRadius: '0!important',
                                fontFamily: 'Circular Spotify Tx T Book'
                              }}>
                              {t('login')}
                            </Button>
                          </Grid>
                        </Grid>
                      </Grid>
                    </UnauthenticatedTemplate>
                  )}
                </>
              )
            }
          </Grid>
        </TabPanel>
      </TabContext>
    </Box>
  );
};

const useStyles = makeStyles()((theme) => {
  return {
    modal: {
      '.MuiBackdrop-root': {
        backgroundColor: '#FFF'
      },
      'h3, h6': {
        color: theme.palette.primary.contrastText,
        fontFamily: theme.typography.h1.fontFamily
      },
      h6: {
        fontSize: 18
      },
      top: 30,
      overflow: 'scroll',
      msOverflowStyle: 'none',  /* IE and Edge */
      scrollbarWidth: 'none',  /* Firefox */
      '&::-webkit-scrollbar': {
        display: 'none'
      }
    },
    root: {
      backgroundColor: theme.palette.secondary.main,
      padding: 32,
      height: 'fit-content',
      [theme.breakpoints.down('sm')]: {
        padding: '32px',
        paddingBottom: 80
      },
      h6: {
        fontFamily: theme.typography.h1.fontFamily
      }
    },
    inputPaper: {
      backgroundColor: '#FFF',
      borderRadius: theme.radius.formBorderRadius,
      h6: {
        fontSize: 14,
        fontFamily: theme.typography.h2.fontFamily,
        color: '#9B9B9B'
      },
      '.las.la-arrow-right': {
        color: '#9B9B9B'
      }
    },
    fieldContent: {
      padding: '13px 24px',
      display: 'flex',
      justifyContent: 'space-between',
      alignItems: 'center',
      borderRadius: theme.radius.formBorderRadius,
      i: {
        fontSize: 26
      }
    },
    confirmBtn: {
      backgroundColor: '#000',
      color: '#FFF',
      border: '1px solid #000',
      '&:hover': {
        backgroundColor: '#FFF',
        color: '#000',
        border: '1px solid #000'
      }
    }
  };
});
